import { HttpService } from '../http-service/http.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapService {


  constructor(private httpService: HttpService) { }

  async getPontos(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/ponto/', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })


  }

  async getCaminhos(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/ponto/caminho', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getPontoOnibus(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/ponibus/', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getEstacaoMetro(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/pmetro', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getEstacaoTrem(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/ptrem', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getTrajetosBrt(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/tbrt', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  getTrajetosTrans(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      return this.httpService.get('/transporte/ttrans', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getTrajetosTrem(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/ttrem', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getTrajetosMetro(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/transporte/tmetro', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getSubap(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/limite/subap', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }

  async getLimite(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      return this.httpService.get('/limite/favela', '').subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => {
          reject([]);
        }
      });

    })
  }
}
